import {CrmAnalyticsStore} from './crm-analytics-store'

let sharedCrmAnalyticsStore: CrmAnalyticsStore | null = null

export const useCrmAnalyticsStore = () => {
  if (!sharedCrmAnalyticsStore) {
    sharedCrmAnalyticsStore = new CrmAnalyticsStore()
  }
  return sharedCrmAnalyticsStore
}
